import { render, staticRenderFns } from "./containerSettings.vue?vue&type=template&id=60a90cce&scoped=true"
import script from "./containerSettings.vue?vue&type=script&lang=js"
export * from "./containerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a90cce",
  null
  
)

export default component.exports